module.exports = __webpack_public_path__ + "static/roseGold-49b9df6bd54bb22d353e191ee6eeb7f3.svg";